module.exports = __webpack_public_path__ + "static/media/connector_icon_google-cloud-composer.6eed042a.svg";